import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  CopyOutlined,
  SendOutlined,
} from "@ant-design/icons";
import {
  Badge,
  Button,
  Card,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Tabs,
  Tooltip,
  Typography,
} from "antd";
import axios from "axios";
import { FC, useEffect, useState } from "react";
import { formatUrl, maskValue } from "utils/Common";
import { toastText } from "utils/utils";
import CustomCardTitle from "./CustomCardTitle";
import "./index.scss";
import { ApiLogsDrawerProps } from "./type";
const { Text } = Typography;

const { TabPane } = Tabs;
interface ApiResponse {
  status?: any;
  data?: any;
  error?: any;
  message?: string;
}

const APIKeyDetailedRequestDrawer: FC<ApiLogsDrawerProps> = (props) => {
  const { drawerData, onRequestResent } = props;
  const endPoint = formatUrl(drawerData?.apiUrl);
  const [loading, setLoading] = useState(false);
  const [resendResponse, setResendResponse] = useState<ApiResponse | null>(
    null
  );
  const [form] = Form.useForm();
  const [activeTab, setActiveTab] = useState("1");
  const [modalVisible, setModalVisible] = useState(false);

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    toastText("Copied to clipboard!", "success");
  };

  const isEmptyObject = (obj: any) =>
    obj && typeof obj === "object" && Object.keys(obj).length === 0;

  const handleCancel = () => {
    setModalVisible(false);
  };

  // Initialize form with request data
  console.log("drawerData: ", drawerData);
  useState(() => {
    if (drawerData?.apiRequest?.body) {
      form.setFieldsValue({
        body: JSON.stringify(drawerData.apiRequest.body, null, 2),
        method: drawerData.method,
        url: drawerData.apiUrl,
        headers: JSON.stringify(drawerData?.apiRequest?.header || {}, null, 2),
      });
      console.log("drawerData: ", drawerData);
    }
  });

  const headers = {
    accept: drawerData?.apiRequest?.header?.accept || "application/json",
    authorization: `Bearer ${maskValue(
      drawerData?.apiRequest?.header?.accesstoken
    )}`,
    "content-type":
      drawerData?.apiRequest?.header?.contentType || "application/json",
    "Cache-Control": "no-cache, no-store, must-revalidate",
    Pragma: "no-cache",
    Expires: "0",
  };

  const headersText = headers
    ? Object.entries(headers)
        .map(([key, value]) => `${key}: ${value}`)
        .join("\n")
    : "";

  const handleResendRequest = async () => {
    try {
      setLoading(true);
      const values = form.getFieldsValue();

      // Parse headers and body JSON
      let headers: any = {};
      let body = {};

      try {
        headers = JSON.parse(values.headers);

        // Remove 'if-none-match' if it exists (case-insensitive)
        for (const key in headers) {
          if (key.toLowerCase() === "if-none-match") {
            delete headers[key];
          }
        }

        // Force cache bypass
        headers["Cache-Control"] = "no-cache, no-store, must-revalidate";
        headers["Pragma"] = "no-cache";
        headers["Expires"] = "0";
      } catch (e) {
        toastText(
          "Oops! The headers you provided are not in valid JSON format. Please double-check and try again.",
          "error"
        );
        setLoading(false);
        return;
      }

      try {
        body = values.body ? JSON.parse(values.body) : {};
      } catch (e) {
        toastText(
          "The request body is not in valid JSON format. Please check and try again.",
          "error"
        );
        setLoading(false);
        return;
      }

      console.log("headers: ", headers);

      // Make the request
      const response = await axios({
        method: values.method,
        url: values.url,
        headers,
        data: values.method !== "GET" ? body : undefined,
        params: values.method === "GET" ? body : undefined,
      });

      console.log("response: ", response);
      console.log("response.data: ", response.data);
      const newResponse = {
        status: response.status,
        data: response.data,
        error: null,
        message: "Request sent successfully",
      };
      setResendResponse(newResponse);

      drawerData.status = response.status;
      drawerData.apiResponse = {
        data: response.data,
        error: null,
        message: "Request sent successfully",
      };

      toastText("Your request was sent successfully!", "success");
      // setModalVisible(false);

      setActiveTab("2"); // Switch to resend response tab

      if (onRequestResent) {
        onRequestResent(response.data);
      }
    } catch (error: any) {
      toastText(
        "Oops! Something went wrong while sending your request.",
        "error"
      );
      const errorResponse = {
        status: error.response?.status || 500,
        data: null,
        error: error.response?.data || { error: error.message },
        message: "Request Failed",
      };

      // Update resendResponse state
      setResendResponse(errorResponse);
      drawerData.status = error.response?.status || 500;
      drawerData.apiResponse = {
        data: null,
        error: error.response?.data || { error: error.message },
        message: "Request Failed",
      };

      console.log("error.message: ", error.message);
      console.log("error.response?.data: ", error.response?.data);

      // Close modal and switch to response tab
      // setModalVisible(false);
      setActiveTab("2");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab !== "2") {
      setResendResponse(null);
    }
  }, [activeTab]);
  // useEffect(() => {
  //     if (resendResponse) {
  //         console.log('resendResponse: ', resendResponse);
  //         drawerData.status = resendResponse.status;
  //         drawerData.apiResponse = {
  //             data: resendResponse.data,
  //             error: resendResponse.error,
  //             message: resendResponse.message
  //         };
  //     }
  // }, [resendResponse]);
  return (
    <div className="drawer-scroll-wrapper">
      <div className={"req-detail-body"}>
        <Row justify="space-between">
          <Col>
            <Space size={20}>
              <Card
                title={
                  <CustomCardTitle
                    drawerData={drawerData}
                    setModalVisible={setModalVisible}
                  />
                }
                className={"card-width"}
              >
                <Card.Grid hoverable={false} style={gridStyle}>
                  <p className={"content-heading"}>Integration</p>
                  <p className={"content-heading__sub-heading"}>
                    {drawerData?.Integration}
                  </p>
                </Card.Grid>
                <Card.Grid hoverable={false} style={gridStyle}>
                  <p className={"content-heading"}>API</p>
                  <p className={"content-heading__sub-heading"}>
                    {drawerData?.apiName}
                  </p>
                </Card.Grid>
                <Card.Grid hoverable={false} style={gridStyle}>
                  <p className={"content-heading"}>Timestamp</p>
                  <p className={"content-heading__sub-heading"}>
                    {drawerData?.createdAt}
                  </p>
                </Card.Grid>
                <Card.Grid hoverable={false} style={gridStyle}>
                  <p className={"content-heading"}>Status</p>
                  <p className={"content-heading__sub-heading"}>
                    <Space>
                      <Badge
                        count={0}
                        style={
                          drawerData?.status == "200"
                            ? {
                                backgroundColor: "#52c41a",
                                color: "#52c41a",
                                fontSize: "5px",
                              }
                            : {
                                backgroundColor: "#FAAD14",
                                color: "#FAAD14",
                                fontSize: "5px",
                              }
                        }
                        showZero={true}
                      />
                      <span style={{ fontSize: "12px" }}>
                        {drawerData?.status}
                      </span>
                    </Space>
                  </p>
                </Card.Grid>
                <Card.Grid hoverable={false} style={gridStyle}>
                  <p className={"content-heading"}>Duration</p>
                  <p className={"content-heading__sub-heading"}>
                    {drawerData?.duration} ms
                  </p>
                </Card.Grid>
                <Card.Grid hoverable={false} style={gridStyle}>
                  <p className={"content-heading"}>Full URL</p>
                  <Tooltip title={drawerData?.apiUrl} placement="bottom">
                    {" "}
                    <p className={"content-heading__sub-heading fullUrl"}>
                      {drawerData?.apiUrl}
                    </p>
                  </Tooltip>
                </Card.Grid>
                <Card.Grid
                  hoverable={false}
                  style={{
                    width: "50%",
                    boxShadow: "none",
                    textAlign: "left",
                    border: "none",
                  }}
                >
                  <p className={"content-heading"}>Request ID</p>
                  <p className={"content-heading__sub-heading"}>
                    {drawerData?.id}
                  </p>
                </Card.Grid>
              </Card>
            </Space>
          </Col>
        </Row>

        <Row className={"mt-1"}>
          <Col span={24}>
            <Tabs activeKey={activeTab} onChange={setActiveTab}>
              <TabPane tab="Request" key="1">
                <Row gutter={24}>
                  <Col span={24}>
                    <div style={{ marginBottom: 20 }}>
                      {/* Method & Endpoint */}
                      <Text
                        strong
                        style={{
                          fontSize: 13,
                          display: "block",
                          marginBottom: 8,
                        }}
                      >
                        METHOD & ENDPOINT
                      </Text>
                      <div
                        style={{
                          background: "#f6f8fa",
                          padding: "10px",
                          borderRadius: 6,
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          fontSize: 13,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                          }}
                        >
                          <span
                            style={{
                              backgroundColor: "#e6f4ff",
                              color: "#1677ff",
                              fontWeight: 600,
                              padding: "2px 8px",
                              borderRadius: 4,
                              fontSize: 12,
                            }}
                          >
                            {drawerData?.method?.toUpperCase()}
                          </span>
                          <span>{endPoint}</span>
                        </div>
                        <Button
                          icon={<CopyOutlined />}
                          type="link"
                          size="small"
                          style={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            zIndex: 1,
                          }}
                          onClick={() => copyToClipboard(endPoint || "")}
                        >
                          Copy
                        </Button>
                      </div>
                    </div>

                    {/* Headers */}
                    <div style={{ marginBottom: 12 }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Text strong style={{ fontSize: 13 }}>
                          HEADERS
                        </Text>
                        <Button
                          type="link"
                          icon={<CopyOutlined />}
                          size="small"
                          onClick={() => copyToClipboard(headersText || "")}
                        >
                          Copy
                        </Button>
                      </div>

                      <div
                        style={{
                          background: "#f6f8fa",
                          padding: "12px",
                          borderRadius: 6,
                          fontSize: 13,
                          marginTop: 6,
                        }}
                      >
                        {Object.entries(headers).map(([key, value], index) => (
                          <div key={index} style={{ marginBottom: 5 }}>
                            <Text style={{ fontWeight: 600, fontSize: 12 }}>
                              {key} :
                            </Text>{" "}
                            <Text style={{ fontSize: 12 }}>{value}</Text>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Request ID */}
                    <Text
                      strong
                      style={{
                        fontSize: 13,
                        display: "block",
                        margin: "16px 0 8px",
                      }}
                    >
                      REQUEST ID
                    </Text>
                    <div
                      style={{
                        background: "#f6f8fa",
                        padding: "10px",
                        borderRadius: 6,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontSize: 13,
                      }}
                    >
                      <Text style={{ fontSize: 12 }}>{drawerData?.id}</Text>
                      <div className="copy-button">
                        <Button
                          icon={<CopyOutlined />}
                          type="link"
                          size="small"
                          onClick={() => copyToClipboard(drawerData?.id || "")}
                        >
                          Copy
                        </Button>
                      </div>
                    </div>

                    {/* Request Body */}
                    <Text
                      strong
                      style={{
                        fontSize: 13,
                        display: "block",
                        margin: "16px 0 8px",
                      }}
                    >
                      REQUEST BODY
                    </Text>
                    {drawerData?.apiRequest?.body &&
                    !isEmptyObject(drawerData?.apiRequest?.body) ? (
                      <div style={{ position: "relative" }}>
                        <Button
                          icon={<CopyOutlined />}
                          type="link"
                          size="small"
                          style={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            zIndex: 1,
                          }}
                          onClick={() =>
                            copyToClipboard(
                              JSON.stringify(
                                drawerData?.apiRequest?.body,
                                null,
                                2
                              )
                            )
                          }
                        >
                          Copy
                        </Button>
                        <pre
                          style={{
                            backgroundColor: "#f6f8fa",
                            padding: "10px",
                            borderRadius: 6,
                            fontSize: "12px",
                            whiteSpace: "pre-wrap",
                            wordWrap: "break-word",
                            maxHeight: 300,
                            overflowY: "auto",
                          }}
                        >
                          {JSON.stringify(
                            drawerData?.apiRequest?.body,
                            null,
                            2
                          )}
                        </pre>
                      </div>
                    ) : (
                      <Text type="secondary" style={{ fontSize: 12 }}>
                        No Request body available
                      </Text>
                    )}
                  </Col>
                </Row>
              </TabPane>

              {/* Tab 2 - Response Tab with Updated Copy Functionality */}
              <TabPane tab="Response" key="2">
                <Row gutter={24}>
                  <Col span={24}>
                    {/* METHOD & ENDPOINT */}
                    <div style={{ marginBottom: 20, position: "relative" }}>
                      <Text
                        strong
                        style={{
                          fontSize: 13,
                          display: "block",
                          marginBottom: 8,
                        }}
                      >
                        METHOD & ENDPOINT
                      </Text>
                      <Button
                        icon={<CopyOutlined />}
                        type="link"
                        size="small"
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          zIndex: 1,
                        }}
                        onClick={() => copyToClipboard(endPoint || "")}
                      >
                        Copy
                      </Button>
                      <div
                        style={{
                          background: "#f6f8fa",
                          padding: "10px",
                          borderRadius: 6,
                          display: "flex",
                          alignItems: "center",
                          fontSize: 13,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                          }}
                        >
                          <span
                            style={{
                              backgroundColor: "#e6f4ff",
                              color: "#1677ff",
                              fontWeight: 600,
                              padding: "2px 8px",
                              borderRadius: 4,
                              fontSize: 12,
                            }}
                          >
                            {drawerData?.method?.toUpperCase()}
                          </span>
                          <span>{endPoint}</span>
                        </div>
                      </div>
                    </div>

                    {/* HEADERS */}
                    <div style={{ marginBottom: 20, position: "relative" }}>
                      <Text
                        strong
                        style={{
                          fontSize: 13,
                          display: "block",
                          marginBottom: 8,
                        }}
                      >
                        HEADERS
                      </Text>
                      <Button
                        icon={<CopyOutlined />}
                        type="link"
                        size="small"
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          zIndex: 1,
                        }}
                        onClick={() =>
                          copyToClipboard(
                            drawerData?.apiRequest?.header?.accept || ""
                          )
                        }
                      >
                        Copy
                      </Button>
                      <div
                        style={{
                          background: "#f6f8fa",
                          padding: "10px",
                          borderRadius: 6,
                          fontSize: 13,
                        }}
                      >
                        <p style={{ marginBottom: 4, fontWeight: 600 }}>
                          content-type:
                        </p>
                        <p style={{ fontSize: 12, margin: 0 }}>
                          {drawerData?.apiRequest?.header?.accept}
                        </p>
                      </div>
                    </div>

                    {/* RESPONSE BODY */}
                    <div style={{ marginTop: 10, position: "relative" }}>
                      <Text
                        strong
                        style={{
                          fontSize: 13,
                          display: "block",
                          marginBottom: 8,
                        }}
                      >
                        RESPONSE BODY
                      </Text>
                      {(drawerData?.apiResponse?.data ||
                        drawerData?.apiResponse?.error ||
                        drawerData?.apiResponse?.message) && (
                        <Button
                          icon={<CopyOutlined />}
                          type="link"
                          size="small"
                          style={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            zIndex: 1,
                          }}
                          onClick={() =>
                            copyToClipboard(
                              JSON.stringify(
                                {
                                  ...(drawerData?.apiResponse?.data && {
                                    data: drawerData.apiResponse.data,
                                  }),
                                  ...(drawerData?.apiResponse?.error && {
                                    error: drawerData.apiResponse.error,
                                  }),
                                  ...(drawerData?.apiResponse?.message && {
                                    message: drawerData.apiResponse.message,
                                  }),
                                },
                                null,
                                2
                              )
                            )
                          }
                        >
                          Copy
                        </Button>
                      )}

                      {drawerData?.apiResponse?.data ||
                      drawerData?.apiResponse?.error ||
                      drawerData?.apiResponse?.message ? (
                        <pre
                          style={{
                            fontSize: 12,
                            whiteSpace: "pre-wrap",
                            wordWrap: "break-word",
                            backgroundColor: "#f6f8fa",
                            padding: "10px",
                            borderRadius: "4px",
                            maxHeight: 300,
                            overflowY: "auto",
                          }}
                        >
                          {JSON.stringify(
                            {
                              ...(drawerData?.apiResponse?.data && {
                                data: drawerData.apiResponse.data,
                              }),
                              ...(drawerData?.apiResponse?.error && {
                                error: drawerData.apiResponse.error,
                              }),
                              ...(drawerData?.apiResponse?.message && {
                                message: drawerData.apiResponse.message,
                              }),
                            },
                            null,
                            2
                          )}
                        </pre>
                      ) : (
                        <p style={{ fontSize: 12, color: "#888" }}>
                          No response body available
                        </p>
                      )}
                    </div>
                  </Col>
                </Row>
              </TabPane>
            </Tabs>
          </Col>
        </Row>
      </div>

      <Modal
        title={
          <span style={{ fontWeight: "bold", fontSize: "18px" }}>
            Resend Request
          </span>
        }
        open={modalVisible}
        onCancel={handleCancel}
        footer={null}
        width={900}
        centered
      >
        <div
          style={{ maxHeight: "600px", overflowY: "auto", paddingRight: 16 }}
        >
          <Row gutter={24}>
            <Col span={resendResponse ? 12 : 24} style={{ width: "100%" }}>
              <Card className="card-border">
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={handleResendRequest}
                >
                  {/* Request Method and URL */}
                  <Form.Item
                    label={
                      <span
                        style={{
                          fontSize: 13,
                          display: "block",
                          marginBottom: 3,
                          marginTop: 10,
                        }}
                      >
                        <strong>REQUEST</strong>
                      </span>
                    }
                  >
                    <div style={{ position: "relative" }}>
                      <Button
                        icon={<CopyOutlined />}
                        type="link"
                        size="small"
                        style={{
                          position: "absolute",
                          top: -30,
                          right: 0,
                          zIndex: 1,
                          fontSize: 13,
                        }}
                        onClick={() => copyToClipboard(endPoint || "")}
                      >
                        Copy
                      </Button>
                      <div
                        style={{
                          background: "#f6f8fa",
                          padding: "10px",
                          borderRadius: 6,
                          display: "flex",
                          alignItems: "center",
                          fontSize: 13,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                          }}
                        >
                          <span
                            style={{
                              backgroundColor: "#e6f4ff",
                              color: "#1677ff",
                              fontWeight: 600,
                              padding: "2px 8px",
                              borderRadius: 4,
                              fontSize: 12,
                            }}
                          >
                            {drawerData?.method?.toUpperCase()}
                          </span>
                          <span>{endPoint}</span>
                        </div>
                      </div>
                    </div>
                  </Form.Item>

                  {/* Method */}
                  <Form.Item
                    label={
                      <span
                        style={{ fontSize: 13, marginBottom: 8, marginTop: 8 }}
                      >
                        <strong>METHOD</strong>
                      </span>
                    }
                    name="method"
                  >
                    <div style={{ position: "relative" }}>
                      <Button
                        icon={<CopyOutlined />}
                        type="link"
                        size="small"
                        style={{
                          position: "absolute",
                          top: -30,
                          right: 0,
                          zIndex: 1,
                          fontSize: 13,
                        }}
                        onClick={() =>
                          copyToClipboard(drawerData?.method || "")
                        }
                      >
                        Copy
                      </Button>
                      <pre
                        style={{
                          fontSize: "12px",
                          backgroundColor: "#f6f8fa",
                          padding: "10px",
                          borderRadius: "4px",
                          whiteSpace: "pre-wrap",
                          wordWrap: "break-word",
                        }}
                      >
                        {drawerData?.method}
                      </pre>
                    </div>
                  </Form.Item>

                  {/* URL */}
                  <Form.Item
                    label={
                      <span
                        style={{ fontSize: 13, marginBottom: 8, marginTop: 8 }}
                      >
                        <strong>URL</strong>
                      </span>
                    }
                    name="url"
                  >
                    <div style={{ position: "relative" }}>
                      <Button
                        icon={<CopyOutlined />}
                        type="link"
                        size="small"
                        style={{
                          position: "absolute",
                          top: -30,
                          right: 0,
                          zIndex: 1,
                          fontSize: 13,
                        }}
                        onClick={() =>
                          copyToClipboard(drawerData?.apiUrl || "")
                        }
                      >
                        Copy
                      </Button>
                      <pre
                        style={{
                          fontSize: "12px",
                          backgroundColor: "#f6f8fa",
                          padding: "10px",
                          borderRadius: "4px",
                          whiteSpace: "pre-wrap",
                          wordWrap: "break-word",
                        }}
                      >
                        {drawerData?.apiUrl}
                      </pre>
                    </div>
                  </Form.Item>

                  {/* Headers */}
                  <Form.Item
                    label={
                      <span
                        style={{ fontSize: 13, marginBottom: 8, marginTop: 8 }}
                      >
                        <strong>HEADER (JSON format)</strong>
                      </span>
                    }
                    name="headers"
                  >
                    <div style={{ position: "relative" }}>
                      <Button
                        icon={<CopyOutlined />}
                        type="link"
                        size="small"
                        style={{
                          position: "absolute",
                          top: -30,
                          right: 0,
                          zIndex: 1,
                          fontSize: 13,
                        }}
                        onClick={() =>
                          copyToClipboard(form.getFieldValue("headers") || "{}")
                        }
                      >
                        Copy
                      </Button>
                      <pre
                        style={{
                          fontSize: "12px",
                          backgroundColor: "#f6f8fa",
                          padding: "10px",
                          borderRadius: "4px",
                          whiteSpace: "pre-wrap",
                          wordWrap: "break-word",
                        }}
                      >
                        {form.getFieldValue("headers") || "{}"}
                      </pre>
                    </div>
                  </Form.Item>

                  {/* Request Body */}
                  <Form.Item
                    name="body"
                    label={
                      <span
                        style={{
                          fontSize: 13,
                          display: "block",
                          marginBottom: 8,
                          marginTop: 8,
                        }}
                      >
                        <strong>REQUEST BODY (JSON format)</strong>
                      </span>
                    }
                    rules={[
                      {
                        validator: async (_, value) => {
                          if (value) {
                            try {
                              JSON.parse(value);
                            } catch (e) {
                              throw new Error("Invalid JSON format");
                            }
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input.TextArea
                      rows={7}
                      style={{
                        fontSize: "12px",
                        fontFamily: "monospace",
                        backgroundColor: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                      }}
                    />
                  </Form.Item>

                  {/* Submit Button */}
                  <Form.Item>
                    <div className="send-button">
                      <Button
                        type="primary"
                        htmlType="submit"
                        icon={<SendOutlined />}
                        loading={loading}
                        className="send-button"
                      >
                        Send Request
                      </Button>
                    </div>
                  </Form.Item>
                </Form>
              </Card>
            </Col>

            <Col span={12} style={{ width: "100%" }}>
              <Card className="card-border">
                {/* Response Section */}
                {resendResponse && (
                  <div style={{ marginTop: "20px" }}>
                    <p
                      style={{
                        fontSize: 13,
                        display: "block",
                        marginBottom: 8,
                        marginTop: 8,
                      }}
                    >
                      <strong>RESPONSE</strong>
                    </p>
                    {resendResponse?.status && (
                      <div
                        style={{
                          backgroundColor:
                            resendResponse.status === 200
                              ? "#f6ffed"
                              : "#fff1f0",
                          border: `1px solid ${
                            resendResponse.status === 200
                              ? "#b7eb8f"
                              : "#ffa39e"
                          }`,
                          borderRadius: 6,
                          padding: "12px 16px",
                          display: "flex",
                          alignItems: "center",
                          gap: 12,
                          marginTop: 24,
                          maxWidth: 800,
                          marginBottom: "20px",
                        }}
                      >
                        {resendResponse.status === 200 ? (
                          <CheckCircleOutlined
                            style={{ color: "green", fontSize: 20 }}
                          />
                        ) : (
                          <CloseCircleOutlined
                            style={{ color: "red", fontSize: 20 }}
                          />
                        )}
                        <div>
                          <div
                            style={{
                              fontWeight: 600,
                              color:
                                resendResponse.status === 200
                                  ? "#389e0d"
                                  : "#ff4d4f",
                            }}
                          >
                            {resendResponse.status === 200
                              ? "Request Successful"
                              : "Request Failed"}
                          </div>
                          <div
                            style={{
                              fontSize: 13,
                              color:
                                resendResponse.status === 200
                                  ? "#389e0d"
                                  : "#ff4d4f",
                            }}
                          >
                            Response received with status{" "}
                            {resendResponse.status}
                          </div>
                        </div>
                      </div>
                    )}

                    <p className={"req-header-title__sub-title"}>
                      Response Body
                    </p>
                    <Input.TextArea
                      rows={35}
                      readOnly
                      value={JSON.stringify(
                        {
                          ...(resendResponse?.data && {
                            data: resendResponse.data,
                          }),
                          ...(resendResponse?.error && {
                            error: resendResponse.error,
                          }),
                          ...(resendResponse?.message && {
                            message: resendResponse.message,
                          }),
                        },
                        null,
                        2
                      )}
                      style={{
                        fontSize: "12px",
                        fontFamily: "monospace",
                        backgroundColor: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                      }}
                    />
                  </div>
                )}
              </Card>
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
  );
};

export default APIKeyDetailedRequestDrawer;

const gridStyle: React.CSSProperties = {
  width: "30%",
  textAlign: "left",
  border: "none",
  boxShadow: "none",
};
